import { useTranslation } from "react-i18next";
import { Header } from "@common/components";
import usePackageWithLeaguesStore from "../../hooks/use-package-with-leagues-store";
import type { PackageCreationWizardStep } from "../../types";

interface PackageCreationHeaderProps {
  homePath: string;
}

const titleKeyByStep: Record<PackageCreationWizardStep, string> = {
  "package-details": "create-package.description",
  "league-configuration": "package-wizard.leagues.title",
  "initial-groups": "package-wizard.groups.title",
};

const PackageCreationHeader = ({ homePath }: PackageCreationHeaderProps) => {
  const { t } = useTranslation();
  const currentStep = usePackageWithLeaguesStore(state => state.currentStep);

  return (
    <Header
      breadcrumbItems={[
        {
          title: t("create-package.breadcrumb.previous"),
          path: homePath,
        },
        {
          title: t("create-package.breadcrumb.current"),
        },
      ]}
      dimension={t("create-package.title")}
      title={t(titleKeyByStep[currentStep])}
    />
  );
};

export default PackageCreationHeader;
